import React from 'react'

import TopRUPageContent from './TopRUPageContent'

export const TopRUPage: React.FC = () => {
  return <TopRUPageContent />
}

export default TopRUPage
